import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { getRoles } from "../../redux/actions/roleActions";
import { castEnumForDisplay } from "../../helpers/enumHelpers";
import AppSelectFilter from "./AppSelectFilter";

interface Props {
  value: string;
  onChange: (roleId: string) => void;
  label?: string;
  allLabel?: string;
  minWidth?: number | string;
}

export const RoleSelectFilter: React.FC<Props> = ({
  value,
  onChange,
  label = "Role",
  allLabel = "All Roles",
  minWidth = 150,
}) => {
  const dispatch = useAppDispatch();
  const {
    items: roles,
    loadingFetchAll: loading,
    errorFetchAll: error,
  } = useAppSelector((state) => state.role);
  const attempted = useRef(false);

  useEffect(() => {
    if (!roles.length && !loading && !error && !attempted.current) {
      attempted.current = true;
      dispatch(getRoles());
    }
  }, [dispatch, roles.length, loading, error]);

  return (
    <AppSelectFilter
      label={label}
      value={value}
      onChange={onChange}
      options={roles.map((r) => ({
        value: r.id,
        label: castEnumForDisplay(r.name) ?? r.name,
      }))}
      allLabel={allLabel}
      minWidth={minWidth}
    />
  );
};
export default RoleSelectFilter;
